var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7406 7.50937C21.5278 7.27224 21.2677 7.0822 20.9771 6.95143C20.6865 6.82066 20.3718 6.75205 20.0531 6.75H15V5.25C14.9975 4.2562 14.6016 3.30381 13.8989 2.60108C13.1962 1.89836 12.2438 1.50248 11.25 1.5C11.1107 1.50113 10.9743 1.54011 10.8554 1.61276C10.7365 1.68542 10.6396 1.78903 10.575 1.9125L7.03125 9H3C2.60218 9 2.22064 9.15804 1.93934 9.43934C1.65804 9.72064 1.5 10.1022 1.5 10.5V18.75C1.5 19.1478 1.65804 19.5294 1.93934 19.8107C2.22064 20.092 2.60218 20.25 3 20.25H18.9281C19.4754 20.2477 20.0032 20.0469 20.4136 19.6848C20.824 19.3227 21.089 18.824 21.1594 18.2812L22.2844 9.28125C22.3218 8.96434 22.2928 8.6431 22.1992 8.33803C22.1055 8.03296 21.9494 7.75074 21.7406 7.50937ZM3 10.5H6.75V18.75H3V10.5Z",
    fill: "#00C271"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.4afad0ee2038083b25ba205e686ab1f5.svg";
export { ForwardRef as ReactComponent };